import { TABLE_CONSTANTS, useTableServerSideFiltering, useTableFilter, ROUTER_PATHS } from "@/shared";
import { useFetchGetBras } from "@/shared/actions/erp/configuracion-red/bras.actions";
import { GeneralTable } from "@/shared/components/ui";
import { IBras } from "@/shared/interfaces/erp/configuracion-red/bras/bras.interface";
import { Edit } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useTableColumnsBras } from "../../hook/useTableColumnsBras";
import { useNavigate } from "react-router-dom";


export default function TableBras() {

  const navigate = useNavigate();

  ///* store

  const { columnsBras } = useTableColumnsBras();
  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;


  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* react query
  const { isLoading, data: dataBras,
    isRefetching, } = useFetchGetBras(
      {
        enabled: true,
        params: {
          page: pageIndex + 1,
          page_size: pageSize,
          ...filterObject,
          filterByState: false
        }
      }
    );


  return (
    <Grid container spacing={2} >


      <Grid item xs={12}>
        <GeneralTable<IBras>
          columns={columnsBras}
          data={dataBras?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataBras?.data?.count}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}

          // crud
          canEdit={false}
          showCustomActionBtnSpace={true}
          enableColumnActions={true} /// 
          enableEditing={true}

          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
          customActionBtnSpace={(value) => {
            //console.log(value)
            return (
              <Tooltip title={'Editar'} placement="top">
                <IconButton
                  onClick={() => {
                    navigate(`${ROUTER_PATHS.configuracionRED.brasEditarNav}/${value.id_bras}`);
                  }}
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            )
          }}
        />
      </Grid>
    </Grid >
  )

}